module.exports = __webpack_public_path__ + "img/hasOrder.4cd101ea.png";